import { SmartPowerSettingsFormModel, SmartPowerSettingsModel } from 'src/Libs/smart-power/models'

const modelToSettingsFormTransformer = (model: SmartPowerSettingsModel): SmartPowerSettingsFormModel => ({
  emsPowersaveEnabled: model.emsPowersaveEnabled,
  emsPowerLimitsUsed: model.emsPowerLimitsUsed,
  emsMaxChargePower: model.emsMaxChargePower,
  emsMaxDischargePower: model.emsMaxDischargePower,
  emsDischargeStartPower: model.emsDischargeStartPower,
})
export default modelToSettingsFormTransformer
